// import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "components/DashboardNavbar";

import { create, updateById } from "services/VehicleModels";
import { useNavigate, useParams } from "react-router-dom";
import { useMaterialUIController, setErrorSB, setSuccessSB } from "context";

import { Formik } from "formik";
import * as Yup from "yup";
import useLocale from "context/useLocale";
import compressImage from "util/compress";
import VehicleModelFormik from "./form";

function VehicleModelForm() {
  const locale = useLocale();
  const { id, typeId } = useParams();
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const submitForm = async (values) => {
    const form = new FormData();
    form.append("title_ar", values.titleAr);
    form.append("title_en", values.titleEn);
    if (values.mainImage instanceof File) {
      form.append("main_image", await compressImage(values.mainImage), values.mainImage.name);
    } else if (typeof values.mainImage === "object" && values.mainImage.file instanceof File) {
      form.append("main_image", await compressImage(values.mainImage.file), values.mainImage.name);
    } else {
      form.append("main_image", values.mainImage);
    }
    form.append("brand_id", values.brandId);
    form.append("vehicle_type_id", typeId);
    if (values.categoryId) {
      form.append("vehicle_category_id", values.categoryId);
    }
    if (id) {
      await updateById(id, form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.title.en} model has been updated`);
          setTimeout(() => {
            navigate(`/dashboard/vehicleModel/${typeId}/`);
          }, 500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    } else {
      await create(form).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.title.en} model has been created`);
          setTimeout(() => {
            navigate(`/dashboard/vehicleModel/${typeId}/`);
          }, 1500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {locale("modelsForm")}
                </MDTypography>
              </MDBox>
              <MDBox p={4}>
                <Formik
                  initialValues={{
                    titleEn: "",
                    titleAr: "",
                    mainImage: "",
                    brandId: "",
                    categoryId: "",
                  }}
                  onSubmit={async (values) => {
                    await submitForm(values);
                  }}
                  validationSchema={Yup.object().shape({
                    titleEn: Yup.string().required("Field is required"),
                    titleAr: Yup.string().required("Field is required"),
                    mainImage: Yup.mixed().required("Image is required"),
                    brandId: Yup.string().required("Field is required"),
                    categoryId: Yup.string().notRequired(),
                  })}
                >
                  <VehicleModelFormik />
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default VehicleModelForm;
